import { mdxComponents as mdxComps } from 'developer-docs-mdx-components';
import LinkWithTracking from '../components/mdx/LinkWithTracking';
export const mdxComponents = Object.assign({}, mdxComps, {
  LinkWithTracking
});
export const retrieveAllMdxPaths = obj => {
  return Object.entries(obj).reduce((acc, [key, values]) => {
    const valueToKey = value => `./${key}/${value}`;
    if ('spec' in values) {
      acc.push(...values.spec.map(valueToKey));
      acc.push(...values.mdx.map(valueToKey));
      return acc;
    }
    acc.push(...values.map(valueToKey));
    return acc;
  }, []);
};
export const docsCtxKeyToPath = ctxKey => {
  return ctxKey.replace('.', '').replace(/\.mdx$/, '');
};
export const docsPathToCtxKey = docsPath => {
  return `${docsPath.replace(/^\/doc/, '.')}`;
};